import { type ReactNode } from "react";
import { AnimatePresence, motion } from "framer-motion";

interface AnimatedRevealProps {
  isVisible: boolean | undefined;
  children: ReactNode;
}

export function AnimatedReveal({ isVisible, children }: AnimatedRevealProps) {
  return (
    <AnimatePresence initial={false}>
      {!!isVisible && (
        <motion.div
          initial={{ height: 0, opacity: 0 }}
          animate={{ height: "auto", opacity: 1 }}
          exit={{ height: 0, opacity: 0 }}
          transition={{ duration: 0.25, ease: [0.16, 1, 0.3, 1] }}
          style={{ overflow: "hidden" }}
        >
          {children}
        </motion.div>
      )}
    </AnimatePresence>
  );
}
